/**
 * Quick Search component.
 */
customElements.get('yo-quick-search') ??
  customElements.define(
    'yo-quick-search',
    class YO_QuickSearch extends HTMLElement {
      constructor() {
        super();

        this.ns = '[YO/QuickSearch]';

        this.form = this.querySelector('form');
        this.input = this.querySelector('[type="search"]');
        this.button = this.querySelector('[type="submit"]');

        this.results = this.querySelector('.yoqs-results');
        this.suggestions = this.querySelector('.yoqs-results__suggestions');
        this.products = this.querySelector('.yoqs-results__products');
        this.pages = this.querySelector('.yoqs-results__pages');

        this.isOpen = false;
        this.abortController = new AbortController();

        // Setup event listeners

        this.input.addEventListener(
          'input',
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this),
        );

        if (this.input.value !== '') {
          this.input.dispatchEvent(new Event('input'));
        }

        console.log(`${this.ns}`, this);
      }

      getQuery() {
        return this.input.value.trim();
      }

      open() {
        this.classList.add('open');
        this.isOpen = true;
      }

      close() {
        // TODO: Restore initial results
        this.classList.remove('open');
        this.isOpen = false;
      }

      onChange(event) {
        const query = this.getQuery();
        console.log(`${this.ns} onChange`, query);

        if (!query.length) {
          this.close();
          return;
        }

        // TODO: Cache search results

        this.abortController.abort();
        this.abortController = new AbortController();

        // Fetch Suggestions
        this.fetchResults(
          `${routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=yo-predictive-search&resources[type]=query,collection`,
          'YOQuickSearch-Suggestions',
          this.suggestions,
        );

        // Fetch Products
        this.fetchResults(
          `${routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=yo-predictive-search&resources[type]=product&resources[limit]=5`,
          'YOQuickSearch-Products',
          this.products,
        );

        // Fetch Pages
        this.fetchResults(
          `${routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=yo-predictive-search&resources[type]=page,article&resources[limit]=3`,
          'YOQuickSearch-Pages',
          this.pages,
        );
      }

      fetchResults(searchUrl, sourceId, targetEl) {
        fetch(searchUrl, {
          signal: this.abortController.signal,
        })
          .then((response) => {
            if (!response.ok) {
              this.close();
              throw new Error(response.status);
            }

            return response.text();
          })
          .then((text) => {
            const resultsHTML = new DOMParser().parseFromString(text, 'text/html').getElementById(sourceId).innerHTML;

            targetEl.innerHTML = resultsHTML;
          })
          .catch((error) => {
            // Aborted
            if (error?.code === 20) {
              return;
            }

            this.close();
            throw error;
          });
      }
    },
  );
